export default __webpack_public_path__ + "static/media/team_steve_zoomed.a3d3aa4b.png";